import { Box, Checkbox, FlexLayout, Input } from '@deity-io/portal-ui';
import type { FC } from 'react';
import { useState } from 'react';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';

interface InputEditorProps {
  disabled?: boolean;
  value?: string;
  allowEmpty?: boolean;
  onChange?: (value) => void;
}

export const InputEditor: FC<InputEditorProps> = ({ allowEmpty = true, disabled = false, value, onChange }) => {
  const [state, setState] = useState<{ currentEditor: string }>({
    currentEditor: 'raw'
  });

  let editor;
  switch (state.currentEditor) {
    case 'raw':
      editor = (
        <Input
          value={value}
          multiline
          fullWidth
          minRows={10}
          onChange={e => {
            if (onChange) {
              onChange(e.target.value);
            }
          }}
        />
      );
      break;
    case 'json': {
      /** Todo : select right editor   */
      // editor = <JSONEditor value={{}} />;
      let jsonValue;
      try {
        if (value?.trim().length) {
          jsonValue = JSON.parse(value);
        } else {
          jsonValue = undefined;
        }
      } catch (jsonErr) {
        jsonValue = { error: `${jsonErr}` };
      }
      editor = (
        <JSONInput
          id="a_unique_id"
          theme="light_mitsuketa_tribute"
          placeholder={jsonValue}
          locale={locale}
          height="550px"
          width="100%"
          onChange={e => {
            if (onChange && e.error === false) {
              onChange(e.json);
            }
          }}
        />
      );
      break;
    }
    case 'none':
    default:
      editor = (
        <Box
          width="100%"
          style={{
            minHeight: '100px',
            textAlign: 'center',
            borderStyle: 'solid',
            borderColor: '#D4D4D4',
            borderWidth: '1px',
            paddingTop: '20px'
          }}
        >
          This request does not have a body
        </Box>
      );
      break;
  }

  return (
    <Box style={{ marginLeft: '5px', marginRight: '5px' }}>
      <FlexLayout width="full" flexDirection="row" flexWrap="nowrap" alignItems="center">
        {allowEmpty && (
          <Checkbox
            label="none"
            key="none"
            checked={state.currentEditor === 'none'}
            onChange={(e, checked) => {
              if (checked) {
                setState({ ...state, currentEditor: 'none' });
              }
            }}
          />
        )}
        <Checkbox
          label="raw"
          key="raw"
          checked={state.currentEditor === 'raw'}
          onChange={(e, checked) => {
            if (checked) {
              setState({ ...state, currentEditor: 'raw' });
            }
          }}
        />
        <Checkbox
          label="json"
          key="json"
          checked={state.currentEditor === 'json'}
          onChange={(e, checked) => {
            if (checked) {
              setState({ ...state, currentEditor: 'json' });
            }
          }}
        />
        <Checkbox label="xml" key="xml" disabled checked={false} />

        <Checkbox label="csv" key="csv" disabled checked={false} />
      </FlexLayout>
      {editor}
    </Box>
  );
};
